<template>
    <el-dialog :title="title" :modal="false" :visible.sync="isShowCheck" width="400px"
               :close-on-click-modal="false" :show-close="true">
        <div  style="padding-bottom: 40px;position: relative">
        <template >
            <el-checkbox-group v-model="checkList" @change="selCheck" style="width: 100%;height: 400px;overflow: scroll">
                <el-checkbox
                        style="width: 90%"
                        v-for="(item, index) in data" :index="index"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id"></el-checkbox>
            </el-checkbox-group>
        </template>
        <div style="position: absolute;width: 100%;bottom: 0px;text-align: center" >
            <el-button size="mini" type="primary"
                       @click="trueClick">确定</el-button>
        </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "CheckBox",
        props: {
            // 复选框数据
            data: {
                type: Array,
                default () {
                    return [];
                }
            },
            isShowCheck: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            title: {
                type: String,
                default() {
                    return '';
                }
            }
        },
        data(){
            return {
                checkList: [] //复选项
            }
        },
        methods: {
            trueClick(){
                this.$emit('setShow',false)
                let ids = []
                this.data.forEach((item) =>{
                    this.checkList.forEach((i) =>{
                        if(item.name === i){
                            ids.push(item.id)
                        }
                    })
                })
                this.$emit('getValue',ids,this.checkList);
            },
            selCheck(){
                let ids = []
                this.data.forEach((item) =>{
                    this.checkList.forEach((i) =>{
                        if(item.name === i){
                            ids.push(item.id)
                        }
                    })
                })
                this.$emit('getValue',ids,this.checkList);
            }
        }
    }
</script>

<style scoped>

</style>